import VN from "../components/VN";
import { useState, useEffect, useContext } from "react";
import { UserDataContext } from "../components/UserDataContext";
import { useNavigate } from "react-router-dom";
import Alerts from "../components/Alerts";

export default function Expired() {
  const apiResponse = {
    title: "Informacja",
    severity: "warning",
    info: "Konto uległo przedawnieniu lub zostało zablokowane. Skontaktuj się z Administratorem.",
  };
  const { userData } = useContext(UserDataContext);
  const [expire, setExpire] = useState(null);

  const navigate = useNavigate();
  useEffect(() => {
    if (userData && userData.expire) {
      setExpire(userData.expire);
    }
  }, [userData]);

  useEffect(() => {
    if (expire) {
      const compareDateWithToday = (inputDate) => {
        const today = new Date();
        const input = new Date(inputDate);
        if (isNaN(input)) {
          console.error("Nieprawidłowy format daty:", inputDate);
          return;
        }
        today.setHours(0, 0, 0, 0);
        input.setHours(0, 0, 0, 0);

        //if (input >= today) {
        //  navigate("/login" + userData.userId);
        //}
      };
      compareDateWithToday(expire);
    }
  }, [expire, navigate]);

  return (
    <div className="bodyReminder">
      <VN userData={userData} />
      {apiResponse.info !== "" && <Alerts data={apiResponse} />}
    </div>
  );
}
